export const CAPABILITIES = [
  'booking:read',
  'booking:create',
  'booking:update',
  'booking:cancel',
  'billing:read',
  'settlement:read',
  'settlement:upload',
  'deal:read',
  'deal:create',
  'experience:read',
  'experience:create',
  'review:read',
  'metrics:read',
  'business-summary:read',
  'benefit:read',
  'reservation:configure',
  'users:manage',
  'partner-profile:manage',
] as const;

export type Capability = (typeof CAPABILITIES)[number];

export function isCapability(value: string): value is Capability {
  return (CAPABILITIES as readonly string[]).includes(value);
}
